import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import styled, { css } from 'styled-components';
import { formatPrice, getProp, __ } from '../../utilities';
import { selectedConnectionDetail } from '../Connections/selectors';
import { totalPriceSelector } from '../Passengers/selectors';
import { summarySelector } from '../Summary/selectors';
import TicketDetail from './TicketDetail';

const Wrapper = styled.div``;

const GUTTER = 5;

const Row = styled.div`
  margin: 0 ${rem(-GUTTER)};
  display: flex;
  flex-wrap: wrap;
  flex: 1 0 0;
`;

const TicketDetailItem = styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  padding: 0 ${GUTTER}px;
  display: flex;
  ${({ small, theme }) =>
    small &&
    css`
      ${theme.media.sm`
        flex: 1 0 50%;
        max-width: 50%;
      `};
      ${theme.media.md`
        flex: 1 0 33.33%;
        max-width: 33.33%;
      `};
      ${theme.media.lg`
        flex: 1 0 25%;
        max-width: 25%;
      `};
    `};
`;

const TotalPrice = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  ${({ small }) =>
    small &&
    css`
      justify-content: center;
    `};
`;

const SumTitle = styled.div`
  font-size: ${rem(16)};
  line-height: 1.5;
  letter-spacing: ${rem(0.2)};
  color: ${({ theme }) => theme.color.font.primary};
`;

const Price = styled.div`
  margin-left: ${rem(10)};
  font-size: ${rem(20)};
  font-weight: bold;
  color: ${({ theme }) => theme.color.primary};
`;

class Summary extends Component {
  render() {
    const {
      summary,
      className,
      small,
      location: { query },
      connectionDetail: { sectors },
    } = this.props;
    let items = summary;

    if (query.ticketType === 'B') {
      items = sectors.reduce((p, sector) => {
        return [
          ...p,
          {
            persons: [],
            ticket: {
              way1_from: sector.from_bus_stop,
              way1_to: sector.to_bus_stop,
              way1_time_utc_ident: getProp(sector, ['time_utc_ident']),
              way1_time_dest_utc_ident: getProp(sector, [
                'time_dest_utc_ident',
              ]),
              way1_datetime: getProp(sector, ['datetime']),
              way1_datetime_dest: getProp(sector, ['datetime_dest']),
              ...sector,
            },
          },
        ];
      }, []);
    }

    if (!items) {
      return null;
    }

    return (
      <Wrapper className={className}>
        <Row>
          {items.map(item => (
            <TicketDetailItem small={small}>
              <TicketDetail small={small} ticket={item} />
            </TicketDetailItem>
          ))}
        </Row>
        {getProp(this.props, ['totalPrice']) > 0 && (
          <TotalPrice small={small}>
            <SumTitle>{__('Spolu')}</SumTitle>
            <Price>{formatPrice(this.props.totalPrice)}</Price>
          </TotalPrice>
        )}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    summary: summarySelector(state),
    totalPrice: totalPriceSelector(state),
    connectionDetail: selectedConnectionDetail(state),
  };
};

Summary.propTypes = {
  small: PropTypes.bool,
  className: PropTypes.string,
  totalPrice: PropTypes.number,
};

Summary.defaultProps = {
  small: false,
  className: '',
  totalPrice: null,
};

export default connect(mapStateToProps)(withRouter(Summary));



// WEBPACK FOOTER //
// ./src/containers/Summary/index.js